import api from './api.js';

export const messageService = {
  // Get all messages
  getMessages: (params = {}) => api.get('/communication/messages', { params }),
  
  // Get message by ID
  getMessage: (id) => api.get(`/communication/messages/${id}`),
  
  // Send new message
  sendMessage: (data) => api.post('/communication/messages', data),
  
  // Reply to message
  replyToMessage: (messageId, data) => 
    api.post(`/communication/messages/${messageId}/reply`, data),
  
  // Update message
  updateMessage: (id, data) => api.put(`/communication/messages/${id}`, data),
  
  // Delete message
  deleteMessage: (id) => api.delete(`/communication/messages/${id}`),
  
  // Mark message as read
  markAsRead: (id) => api.put(`/communication/messages/${id}/read`),
  
  // Mark message as unread
  markAsUnread: (id) => api.put(`/communication/messages/${id}/unread`),
  
  // Get inbox messages
  getInbox: (params = {}) => api.get('/communication/messages/inbox', { params }),
  
  // Get sent messages
  getSent: (params = {}) => api.get('/communication/messages/sent', { params }),
  
  // Get draft messages
  getDrafts: (params = {}) => api.get('/communication/messages/drafts', { params }),
  
  // Save draft
  saveDraft: (data) => api.post('/communication/messages/drafts', data),
  
  // Update draft
  updateDraft: (id, data) => api.put(`/communication/messages/drafts/${id}`, data),
  
  // Delete draft
  deleteDraft: (id) => api.delete(`/communication/messages/drafts/${id}`),
  
  // Get message thread
  getMessageThread: (messageId) => 
    api.get(`/communication/messages/${messageId}/thread`),
  
  // Get conversation with user
  getConversation: (userId, params = {}) => 
    api.get(`/communication/messages/conversation/${userId}`, { params }),
  
  // Get message recipients
  getRecipients: (params = {}) => api.get('/communication/messages/recipients', { params }),
  
  // Search messages
  searchMessages: (query, params = {}) => 
    api.get('/communication/messages/search', { 
      params: { ...params, q: query } 
    }),
  
  // Get unread count
  getUnreadCount: () => api.get('/communication/messages/unread-count'),
  
  // Mark all as read
  markAllAsRead: () => api.put('/communication/messages/mark-all-read'),
  
  // Archive message
  archiveMessage: (id) => api.put(`/communication/messages/${id}/archive`),
  
  // Get archived messages
  getArchived: (params = {}) => api.get('/communication/messages/archived', { params }),
  
  // Restore archived message
  restoreMessage: (id) => api.put(`/communication/messages/${id}/restore`),
  
  // Forward message
  forwardMessage: (id, data) => 
    api.post(`/communication/messages/${id}/forward`, data),
  
  // Get message attachments
  getAttachments: (messageId) => 
    api.get(`/communication/messages/${messageId}/attachments`),
  
  // Upload message attachment
  uploadAttachment: (messageId, formData) => 
    api.post(`/communication/messages/${messageId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  // Download attachment
  downloadAttachment: (messageId, attachmentId) => 
    api.get(`/communication/messages/${messageId}/attachments/${attachmentId}/download`, {
      responseType: 'blob'
    }),
  
  // Delete attachment
  deleteAttachment: (messageId, attachmentId) => 
    api.delete(`/communication/messages/${messageId}/attachments/${attachmentId}`),

  // Star/unstar message
  toggleStar: (id) => api.put(`/communication/messages/${id}/star`),

  // Get starred messages
  getStarred: (params = {}) => api.get('/communication/messages/starred', { params }),

  // Bulk operations
  bulkMarkAsRead: (messageIds) => 
    api.put('/communication/messages/bulk/read', { messageIds }),

  bulkMarkAsUnread: (messageIds) => 
    api.put('/communication/messages/bulk/unread', { messageIds }),

  bulkArchive: (messageIds) => 
    api.put('/communication/messages/bulk/archive', { messageIds }),

  bulkDelete: (messageIds) => 
    api.put('/communication/messages/bulk/delete', { messageIds }),

  bulkStar: (messageIds) => 
    api.put('/communication/messages/bulk/star', { messageIds }),

  // Message templates
  getTemplates: () => api.get('/communication/messages/templates'),
  
  saveTemplate: (data) => api.post('/communication/messages/templates', data),
  
  updateTemplate: (id, data) => api.put(`/communication/messages/templates/${id}`, data),
  
  deleteTemplate: (id) => api.delete(`/communication/messages/templates/${id}`),

  // Message analytics
  getMessageStats: (params = {}) => 
    api.get('/communication/messages/stats', { params }),

  // Send message with attachments
  sendMessageWithAttachments: (formData) => 
    api.post('/communication/messages/send', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
};
